/* @ngInject */
const accountCtrl = (
  $scope,
  toaster,
  $$account,
  accountLabels,
  userService,
  authService,
  $state,
  labels,
  routes
) => {
  $scope.$$account = $$account
  $scope.authService = authService

  $scope.removeUser = (_username) => {
    if (toaster.confirm(accountLabels.ask.removeUser)) {
      userService.remove(_username)
        .then((message) => {
          toaster.message(message)
        })
        .catch((error) => {
          toaster.message(error)
        })
    }
  }

  $scope.post = () => {
    userService.login($scope.username, $scope.password)
      .then((message) => {
        toaster.message(labels.account.welcome($scope.username))
        $state.go(routes.home.path)
      })
      .catch((error) => {
        toaster.error(error)
      })
    $scope.password = null
  }
}

export default accountCtrl



// WEBPACK FOOTER //
// ./public/javascript/sygem/routing/account/account.controller.js